// components/MonthYearPicker.js
import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const months = [
  'January', 'February', 'March', 'April',
  'May', 'June', 'July', 'August',
  'September', 'October', 'November', 'December',
];

export default function MonthYearPicker({ month, year, onPrev, onNext, onSelectMonth }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMonthTextClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMonthSelect = (index) => {
    onSelectMonth(index);
    setAnchorEl(null);
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center" mb={0} gap={2}>
      <IconButton onClick={onPrev} sx={{
                        background: '#fff',
                        borderRadius: '50px',
                        color: '#1A1F36',
                        fontSize: '16px',
                        textTransform: 'capitalize',
                        width: '40px',
                        height: '38px',
                        border: '1px solid #E5E8EB',
                        '&:hover': {
                            background: '#f5f5f5'
                        }
                    }}>
        <ArrowBackIosNewIcon fontSize="small" />
      </IconButton>

      <Typography
        variant="h6"
        fontWeight={600}
        onClick={handleMonthTextClick}
        sx={{ cursor: 'pointer', userSelect: 'none', color:"#373737", fontSize:'17px', fontWeight:'600', }}
      >
        {months[month]} <span style={{color:"#8C8C8C", fontWeight: '500'}}>{year}</span>
      </Typography>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {months.map((m, idx) => (
          <MenuItem key={m} onClick={() => handleMonthSelect(idx)}>
            {m}
          </MenuItem>
        ))}
      </Menu>

      <IconButton onClick={onNext} sx={{
                        background: '#fff',
                        borderRadius: '50px',
                        color: '#1A1F36',
                        fontSize: '16px',
                        textTransform: 'capitalize',
                        width: '40px',
                        height: '38px',
                        border: '1px solid #E5E8EB',
                        '&:hover': {
                            background: '#f5f5f5'
                        }
                    }}>
        <ArrowForwardIosIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
